import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { DataService } from "../services/data/data.service";

/**
 * Forced-change guard (M7). When the logged-in user's stored
 * `force_password_change` flag is true, every authenticated route is redirected
 * to the forced-change page until they set a new password. The backend also
 * enforces this (E4 is flag-gated), so this guard is a UX redirect, not the
 * security boundary.
 */
@Injectable({ providedIn: "root" })
export class ForcePasswordChangeGuard implements CanActivate {
  constructor(
    private dataService: DataService,
    private router: Router,
  ) {}

  canActivate(): boolean {
    const user = this.dataService.getUserData();
    if (user?.force_password_change === true) {
      this.router.navigate(["/auth/force-password-change"]);
      return false;
    }
    return true;
  }
}
